export default import.meta.ROLLDOWN_FILE_URL_e3FJByPCCgv8fip_DM$mWQ + "?dataUrl"